import { useMutation } from '@tanstack/react-query'

import type { PublishCartPayload } from '../@types'
import { publishCart } from '../api'

const usePublishCart = () => {
  return useMutation({
    mutationKey: ['publishCart'],
    mutationFn: (item: PublishCartPayload['attributes']) =>
      publishCart({
        type: 'cart',
        attributes: item,
      }),
  })
}

export default usePublishCart
